const convertToArray = (x: string | any) => {
  if (typeof x === 'string') {
    return [x]
  }
  return x
}
export default convertToArray
